export default __webpack_public_path__ + "static/media/icon-markup.13b6919c.svg";